import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA4 from 'react-ga4';

// Initialize Google Analytics
ReactGA4.initialize("G-RPFRZBW6V8");

const AnalyticsProvider = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        // Track pageview on location change
        ReactGA4.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location]);

    return children;
};

export default AnalyticsProvider